<script setup lang="ts">
import { RouterLink } from 'vue-router'
</script>

<template>
  <!-- Footer Links -->
  <div class="max-w-4xl mx-auto w-full px-4 sm:px-6 lg:px-8 py-6 sm:py-8">
    <div class="flex flex-wrap gap-4 sm:gap-6 justify-center pt-6 sm:pt-8 border-t border-gray-200">
      <RouterLink
        to="/privacy"
        class="text-sm sm:text-base text-blue-600 hover:text-blue-800 font-medium transition-colors"
      >
        Privacy Policy
      </RouterLink>
      <RouterLink
        to="/terms"
        class="text-sm sm:text-base text-blue-600 hover:text-blue-800 font-medium transition-colors"
      >
        Terms & Conditions
      </RouterLink>
    </div>
  </div>
</template>
